import { terms } from '../../language/terms';

/**
 * The identity of the Product Registry tabs on the company workspace (D-102), kept
 * apart from the registrations and the routes so a journey can read the same id and label the
 * screen renders without importing the router or the domain registration.
 */

/**
 * The products tab's id, which is also the route segment a deep link carries:
 * `maintenance/companies/{groupId}/product-registry-products`. The matching form under
 * `/sites/{loginSiteId}/` went with the site tabs in [D-127].
 */
export const PRODUCTS_TAB_ID = 'product-registry-products';

/** The test reports tab's id, on the same route. */
export const REPORTS_TAB_ID = 'product-registry-reports';

/**
 * The tab labels are the customer's words for the things listed, never a phrase composed here:
 * a rename of either term has to reach the tab (CLAUDE.md, "Domain Words Belong to Terms").
 * The operation type's short code (PSS) is data the catalogue owns (D-067) and is not spelled.
 */
export const PRODUCTS_TAB_LABEL = terms.product.plural;

export const REPORTS_TAB_LABEL = terms.productTestReport.plural;
